import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { id: "footer" }, [
  /*#__PURE__*/_createVNode("div", { class: "container" }, [
    /*#__PURE__*/_createVNode("div", { class: "row" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-md-5 col-sm-6" }, [
        /*#__PURE__*/_createVNode("img", {
          class: "footer-logo",
          src: _imports_0,
          alt: ""
        }),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createVNode("p", null, "Morbi convallis bibendum urna ut viverra. Maecenas quis consequat libero, a feugiat eros. Nunc ut lacinia tortor morbi ultricies laoreet ullamcorper phasellus semper.")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "col-md-4 col-sm-6 " }, [
        /*#__PURE__*/_createVNode("h4", null, "Helpful Links"),
        /*#__PURE__*/_createVNode("ul", { class: "footer-links" }, [
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "Login")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "Sign Up")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "My Account")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "Add Listing")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "Pricing")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "Privacy Policy")
          ])
        ]),
        /*#__PURE__*/_createVNode("ul", { class: "footer-links" }, [
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "FAQ")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "Blog")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "Our Partners")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "How It Works")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "Contact")
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "clearfix" })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "col-md-3  col-sm-12" }, [
        /*#__PURE__*/_createVNode("h4", null, "Contact Us"),
        /*#__PURE__*/_createVNode("div", { class: "text-widget" }, [
          /*#__PURE__*/_createVNode("span", null, "12345 Little Lonsdale St, Melbourne"),
          /*#__PURE__*/_createTextVNode(),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode(" Phone: "),
          /*#__PURE__*/_createVNode("span", null, "(123) 123-456 "),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode(" E-Mail:"),
          /*#__PURE__*/_createVNode("span", null, [
            /*#__PURE__*/_createVNode("a", { href: "#" }, "office@example.com")
          ]),
          /*#__PURE__*/_createVNode("br")
        ]),
        /*#__PURE__*/_createVNode("ul", { class: "social-icons margin-top-20" }, [
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", {
              class: "facebook",
              href: "#"
            }, [
              /*#__PURE__*/_createVNode("i", { class: "icon-facebook" })
            ])
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", {
              class: "twitter",
              href: "#"
            }, [
              /*#__PURE__*/_createVNode("i", { class: "icon-twitter" })
            ])
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", {
              class: "gplus",
              href: "#"
            }, [
              /*#__PURE__*/_createVNode("i", { class: "icon-gplus" })
            ])
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("a", {
              class: "vimeo",
              href: "#"
            }, [
              /*#__PURE__*/_createVNode("i", { class: "icon-vimeo" })
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "row" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-md-12" }, [
        /*#__PURE__*/_createVNode("div", { class: "copyrights" }, "© 2021 Listeo. All Rights Reserved.")
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("footer", null, [
    _hoisted_1
  ]))
}